import styles from './SectionHead.module.css';

export default function SectionHead({ title, sub, right, dark = false }) {
  return (
    <div className={styles.head}>
      <div>
        <h2 className={`${styles.title} ${dark ? styles.titleDark : ''}`}>
          {title}
        </h2>
        {sub && (
          <p className={`${styles.sub} ${dark ? styles.subDark : ''}`}>
            {sub}
          </p>
        )}
      </div>
      {right && <div className={styles.right}>{right}</div>}
    </div>
  );
}
